import React from 'react';
import { ChevronRight, Compass, BookOpen, Target, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Plans({ hasPlans = false, plans = [] }) {
  const navigate = useNavigate();

  // Always show plans - use placeholder content if no real plans provided
  // This ensures the section is visible on the home page
  const displayPlans = plans.length > 0 ? plans.map(plan => ({
    ...plan,
    description: plan.summary || 'No summary available',
    icon: FileText,
    iconColor: '#7C3AED',
    isRealPlan: true
  })) : [
    {
      id: '1',
      title: 'Summer Travel Plans',
      description: 'Planning your next adventure',
      icon: Compass,
      iconColor: '#7C3AED',
      isRealPlan: false
    },
    {
      id: '2',
      title: 'Learning Path',
      description: 'Skills to develop this quarter',
      icon: BookOpen,
      iconColor: '#7C3AED',
      isRealPlan: false
    },
    {
      id: '3',
      title: 'Project Roadmap',
      description: 'Strategic goals and milestones',
      icon: Target,
      iconColor: '#7C3AED',
      isRealPlan: false
    }
  ];

  const handlePlanClick = (plan) => {
    if (plan.isRealPlan) {
      navigate(`/ai-chat?openDocumentId=${plan.id}`);
    }
  };

  return (
    <div className="bg-white rounded-[22px] p-6" style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}>
      <h3 className="text-base font-semibold mb-5 tracking-tight" style={{ color: '#111111' }}>Your Creative Drafts</h3>
      <div className="grid grid-cols-1 gap-3">
        {displayPlans.map((plan) => {
          const Icon = plan.icon;
          const iconColor = plan.iconColor || '#7C3AED';
          return (
            <div
              key={plan.id}
              onClick={() => handlePlanClick(plan)}
              className="group relative overflow-hidden rounded-[20px] p-4 cursor-pointer transition-all duration-300 bg-white"
              style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}
            >
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#7C3AED] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="flex items-start gap-3">
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'rgba(136, 92, 255, 0.06)' }}
                >
                  <Icon size={18} style={{ color: iconColor }} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-[13px] font-semibold mb-1.5" style={{ color: '#111111' }}>{plan.title}</h4>
                  <p className="text-[12px] leading-relaxed mb-2 line-clamp-2" style={{ color: '#555555' }}>
                    {plan.description}
                  </p>
                  <p className="text-[11px]" style={{ color: '#999999' }}>
                    {plan.isRealPlan ? `Updated ${new Date(plan.updated_at).toLocaleDateString()}` : 'Creative space · open anytime'}
                  </p>
                </div>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex-shrink-0">
                  <ChevronRight size={14} style={{ color: '#999999' }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
